<script lang="ts">
  import EncartPromotionParcoursComplet from '../parcours-securisation/EncartPromotionParcoursComplet.svelte';
  import TagProgrammeGratuit from '../parcours-securisation/TagProgrammeGratuit.svelte';
  import Lien from '../ui/Lien.svelte';
  import AccordeonNis2 from './AccordeonNis2.svelte';
  import Marelle from './Marelle.svelte';

  const retourEnHautDePage = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
</script>

<dsfr-container id="presentation">
  <div class="introduction">
    <h2>Qu’est-ce que NIS&nbsp;2&nbsp;?</h2>
    <p>
      La directive NIS 2 permet d’élever le niveau global de cybersécurité par l’application de règles harmonisées et
      simplifiées. Face à une cybermenace qui s’accroît, NIS 2 relève le défi d’une meilleure sécurisation des tissus
      économique et administratif de la France et des pays membres de l'UE.
    </p>
    <p>
      L’ANSSI, en tant qu’autorité nationale en matière de cybersécurité et de cyberdéfense, pilote la transposition en
      droit national de la directive et assure sa mise en œuvre.
    </p>
    <p>
      La transposition de la directive NIS 2 en France est en cours. En attendant la publication de l’ensemble des
      textes de transposition, les futures entités essentielles et importantes sont invitées à s’engager dès à présent
      dans une démarche visant à renforcer leur niveau de sécurité.
    </p>

    <AccordeonNis2 />

    <div class="lien-nis2">
      <Lien href="/nis2#exigences" libelle="Consulter les exigences applicables à NIS 2" surClic={retourEnHautDePage} />
    </div>
  </div>
</dsfr-container>

<dsfr-container class="marelle">
  <Marelle />
</dsfr-container>

<div class="contenu-encart-parcours-securisation">
  <EncartPromotionParcoursComplet
    titre="6 modules pour vous protéger contre les risques les plus courants"
    description="Un programme d'accompagnement gratuit, pensé pour les PME/ETI et les organisations concernées par la directive NIS 2."
    orientation="droite"
  >
    {#snippet tags()}
      <TagProgrammeGratuit />
    {/snippet}
  </EncartPromotionParcoursComplet>
</div>

<style lang="scss">
  @use '../../../assets/styles/responsive' as *;
  @use '../../../assets/styles/grille' as *;

  .introduction {
    margin-inline: auto;
    @include a-partir-de(lg) {
      max-width: taille-pour-colonnes(8);
    }
  }

  .marelle {
    background-color: #f6f6f6;
  }

  .contenu-encart-parcours-securisation {
    margin-top: 48px;
    padding: 96px 0;
    background-color: var(--background-default-grey, white);
  }

  .lien-nis2 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 32px 0 72px;
  }
</style>
